// src/userSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  UserData:[],
  UserActivityData:[],
  ClickUserState:false,
  ClickUserId:'',
  selectedComponent:'Dashbord',
  PartnersTableData:[],
  UserInputid:'',
  PartnerDeatils :[],
  UserLevel:{
    Levels:"",
    LevelAmount:"",
    UserId:""
  }
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserData(state, action) {
      state.UserData = action.payload;
    },
    setUserActivityData(state,action){
      state.UserActivityData=action.payload
    },
    setClickUserState(state,action){
      state.ClickUserState=action.payload
    },
    setClickUserId(state,action){
      state.ClickUserId=action.payload
    },
    setselectedComponent(state,action){
      state.selectedComponent=action.payload
    },
    setPartnersTableData(state,action){
      state.PartnersTableData=action.payload
    },
    setUserInputid(state,action){
      state.UserInputid=action.payload
    },
    setPartnerDeatils(state,action){
      state.PartnerDeatils=action.payload
    },
    setUserLevel(state,action){
      state.UserLevel=action.payload
    }

  },
});

export const {
    setUserData,
    setUserActivityData,
    setClickUserState,
    setClickUserId,
    setselectedComponent,
    setPartnersTableData,
    setUserInputid,
    setPartnerDeatils,
    setUserLevel
} = userSlice.actions;

export default userSlice.reducer;
